import React from "react";
import CategoryPage from "./CategoryPage";

function InkAndEchoStories({
  posts,
  publications
}) {

  return (
    <CategoryPage
      title="Stories"
      parentCategory="Articles"
      subcategoryValues={[
        "Ink and Echo"
      ]}
      subSubcategoryValues={[
        "Stories"
      ]}
      posts={posts}
      publications={publications}
    />
  );

}

export default InkAndEchoStories;